import { render, staticRenderFns } from "./beneficiary-list.vue?vue&type=template&id=53bec7ba&scoped=true"
import script from "./beneficiary-list.vue?vue&type=script&lang=js"
export * from "./beneficiary-list.vue?vue&type=script&lang=js"
import style0 from "./beneficiary-list.vue?vue&type=style&index=0&id=53bec7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bec7ba",
  null
  
)

export default component.exports